import request from '@/utils/request'

// 企微客服列表
export function SpWorkWechatSpCorpUserStatisticsList(params = {}) {
  return request({
    url: '/spWorkWechat/spCorp/userStatisticsList',
    method: 'get',
    params
  })
}
